import { Box, Button, Grid, Theme, createStyles, makeStyles, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_BACKGROUND,
  DARK_FIELDS_ON_CARD_HEADER_LINE,
  DARK_TEXT,
  ERROR_BUTTON_BORDER,
  LIGHT_BACKGROUND,
  LIGHT_HEADER_LINE,
  PLAIN_TEXT,
  PRIMARY_BUTTON_BACKGROUND,
  PRIMARY_BUTTON_BORDER,
  PRIMARY_HEADER_LINE,
  PRIMARY_ICON,
  DARK_CONTAINER_FIELDS_ON_CARD,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
} = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: { paddingTop: 10 },

    heading: {
      position: 'relative',
      borderBottom:
        theme.palette.type === 'dark'
          ? '1px solid' + DARK_FIELDS_ON_CARD_HEADER_LINE
          : '1px solid' + LIGHT_HEADER_LINE + '!important',
      alignItems: 'center',
      paddingBottom: 20,
      marginBottom: 20,

      '&::before': {
        content: '""',
        background: PRIMARY_HEADER_LINE,
        height: '1px',
        position: 'absolute',
        width: 42,
        bottom: '-1px',
      },
    },

    cardItem: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
      border: 'transparent',
      borderRadius: 8,
      padding: '10px 15px',

      '& .MuiSvgIcon-root': {
        marginRight: 15,
        '&.headshotIcon': {
          height: 30,
        },

        '&.fullBodyIcon': {
          height: 30,
        },

        '&.documentIcon path': {
          fill: PRIMARY_ICON,
        },

        '&.microphoneIcon': {
          height: 21,
          marginTop: 3,
        },
      },

      '&:not(:first-child)': {
        marginTop: 15,
      },

      [theme.breakpoints.down('xs')]: {
        padding: '5px 10px',
      },
    },
    buttonContainer: {
      displa: 'flex',
      justifyContent: 'flex-end',
      marginLeft: 'auto',
      width: 120,
      position: 'relative',
      [theme.breakpoints.down('xs')]: {
        width: 'unset',
      },
    },

    completedText: {
      color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    buttonCls: {
      background: 'none',
      height: 32,
      border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
    },
    circle: {
      stroke: 'url(#linearColors)',
      position: 'absolute',
    },
    doneButton: {
      width: 220,
      height: 40,
      backgroundColor: PRIMARY_BUTTON_BACKGROUND,
      marginLeft: 'auto',
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    deleteCont: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
      borderColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
      marginTop: -10,
      padding: 10,
      borderRadius: '8px',
      borderLeft: `1px solid ${theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD}`,
      borderBottom: `1px solid ${theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD}`,
      borderRight: `1px solid ${theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD}`,
      position: 'relative',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        position: 'relative',
      },
    },
    deleteButton: {
      marginLeft: 'auto',
      background: 'none',
      height: 32,
      border: `1px solid ${ERROR_BUTTON_BORDER}`,
      width: 120,
      marginTop: 'auto',
      marginRight: 6,
    },
    loading: {},

    toolTipStyle: {
      background: theme.palette.type === 'dark' ? COLORS.CUSTOMBLACK_DARK_MAIN : LIGHT_BACKGROUND,
      border: `3px solid ${theme.palette.type === 'dark' ? DARK_BACKGROUND : LIGHT_BACKGROUND} !important`,
    },
  }),
);

export const ProgressOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 99,
  [theme.breakpoints.down('xs')]: {
    position: 'unset',
  },
}));

export const MultipleCont = styled(Grid)(({ theme }) => ({
  gap: 20,
}));

export const MultipleItem = styled(Button)<Theme, { required?: boolean }>(({ theme, required }) => ({
  maxHeight: 214,
  maxWidth: 333,
  minHeight: 214,
  minWidth: 333,
  borderRadius: 8,
  margin: '10px 0 5px 0',
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
  border: `2px dashed ${required ? ERROR_BUTTON_BORDER : 'rgb(101 129 159)'}`,
}));

export const MultipleItemCont = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 45,
  position: 'relative',
  [theme.breakpoints.down('xs')]: {
    marginLeft: 0,
  },
}));
